module.exports = __webpack_public_path__ + "img/phone-mobile-hero.34bad50e.webp";